import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { LoadingProvider } from 'contexts/loadingContext'
import { ErrorProvider } from 'contexts/errorContext'
import { AuthProvider } from 'contexts/authContext'
import theme from 'theme'
import App from 'App'

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

root.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <LoadingProvider>
      <ErrorProvider>
        <AuthProvider>
            <App />
        </AuthProvider>
      </ErrorProvider>
    </LoadingProvider>
  </ThemeProvider>
)
